// extracted by mini-css-extract-plugin
module.exports = {"dotLoader":"spinner_dotLoader__3Lg7C","dots-loader":"spinner_dots-loader__3xcOk","dotsLoader":"spinner_dots-loader__3xcOk"};
    if(module.hot) {
      // 1790670232077
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  